import './device-info-card.styles.css';

const DeviceInfoCard = ({ cat }) => {

    const { icon, className, title, info, state, exteraText1, exteraText2 } = cat;

    return (
        <div className={`device-info-card ${className}`}>
            <div className="device-info-title-wrapper">
                <img src={icon} alt="icon" className="device-info-icon" />
                <h4 className="device-info-title-text">
                    {title}
                </h4>
            </div>
            <p className="device-info-text">
                {info}
            </p>
            <div className="device-info-bottom-wrapper">
                <p className="device-info-extra-text">
                    {exteraText1}
                </p>
                <p className="device-info-extra-text">
                    {exteraText2}
                </p>
            </div>
        </div>
    )
}

export default DeviceInfoCard;